import React from "react";
import {Link} from "react-router-dom";

const staff = ["Professor Heidi Probst", "Janet Ulman", "Keeley Rosbottom", "Dr Maria Burton", "Mel Lindley", "Helen Clough", "Jane Barry", "Russ Mather", "Jon Willis"];

const Footer = (props) => {
	return (
		<footer style={styles.top} className="is-small is-primary is-bold">
			<div>
				<img alt="Logo" src={"/images/logo.png"} style={{maxWidth: 100, maxHeight: 300}} />
			</div>
			<div>
				<div style={{textAlign: "right"}}>
					{staff.map((member, index) => ((
						<span style={{marginLeft: 5, marginRight: 5, fontSize: 14}}>{member}{(index === staff.length - 1) ? "" : ","}</span>
					)))}
					<div style={{fontSize: 12, marginTop: 5, textAlign: "right"}}>Website by <a style={{color: "#ffffff"}} href="http://manolisvrondakis.com/">Manolis Vrondakis</a></div>
				</div>
			</div>
		</footer>
	)
};

const styles = {
	top: {
		backgroundColor: "#0e355f",
		padding: 30,
		fontSize: 18,
		color: "#fff",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	link : {
		marginRight: 25,
		color: "#ffffff"
	},
	logo : {
		marginRight: 30
	}
};

export default Footer
